import { Send } from 'lucide-react'
import { useState } from 'react'
import { useRequestIP } from '@/api/hooks/use-ips'

export function IPsPage(): React.JSX.Element {
  const [message, setMessage] = useState('')
  const requestIP = useRequestIP()
  const charCount = message.length

  function handleSubmit(e: React.FormEvent): void {
    e.preventDefault()
    if (message.trim().length < 10) return
    requestIP.mutate(message.trim())
  }

  if (requestIP.isSuccess) {
    return (
      <div className="space-y-6">
        <h1 className="text-2xl font-semibold text-text-primary">Dedicated IPs</h1>
        <div className="flex flex-col items-center justify-center py-24 text-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-green-50">
            <Send className="h-8 w-8 text-green-600" />
          </div>
          <p className="mt-6 text-lg font-medium text-text-primary">Request submitted!</p>
          <p className="mt-1 text-sm text-text-secondary">
            We'll review your request and be in touch within 1-2 business days.
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold text-text-primary">Dedicated IPs</h1>

      <div className="rounded-xl border border-surface-3 bg-surface-0 p-6 shadow-sm">
        <h2 className="text-lg font-semibold text-text-primary">Request a Dedicated IP</h2>
        <p className="mt-2 text-sm text-text-secondary">
          Dedicated IPs with automated warming are available on Growth and Scale plans. Tell us
          about your sending volume and use case, and we'll get you set up.
        </p>

        <form onSubmit={handleSubmit} className="mt-4">
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Tell us about your sending volume, use case, and why you need a dedicated IP..."
            maxLength={2000}
            rows={5}
            className="w-full rounded-lg border border-surface-3 bg-surface-0 p-3 text-sm text-text-primary placeholder:text-text-tertiary focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
          />
          <div className="mt-2 flex items-center justify-between">
            <span className="text-xs text-text-tertiary">{charCount}/2000</span>
            <div className="flex items-center gap-3">
              {requestIP.isError && (
                <span className="text-xs text-danger">
                  {requestIP.error instanceof Error
                    ? requestIP.error.message
                    : 'Something went wrong'}
                </span>
              )}
              <button
                type="submit"
                disabled={requestIP.isPending || message.trim().length < 10}
                className="rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600 disabled:opacity-50"
              >
                {requestIP.isPending ? 'Submitting...' : 'Submit Request'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}
